// eslint-disable-next-line import/prefer-default-export
export const usaTimezones: string[] = [
  "(UTC-10:00) Hawaii",
  "(UTC-09:00) Alaska",
  "(UTC-08:00) Pacific Time (US & Canada)",
  "(UTC-07:00) Mountain Time (US & Canada)",
  "(UTC-06:00) Central America",
  "(UTC-05:00) Eastern Time (US & Canada)",
];
